// dependencies
import React, { lazy } from "react";

// views
import Me from "Pages/Me";
import Login from "Pages/Login";
import MultiFactor from "Pages/MultiFactorLogin";
import Logout from "Pages/Logout";
import Recent from "Pages/Recent";
import Graphs from "Pages/Graphs";
import Requests from "Pages/Requests";
import BugReport from "Pages/BugReport";
import Dashboard from "Pages/Dashboard";
import FlameChart from "Pages/FlameChart";
import Breadcrumbs from "Pages/Breadcrumbs";
import CompanyView from "Pages/Company/View";
import Deployments from "Pages/Deployments";
import FeatureFlags from "Pages/FeatureFlags";
import CreateFeatureFlags from "Pages/FeatureFlags/pages/create-feature-flag";
import BulkUpdateFeatureFlag from "Pages/FeatureFlags/pages/bulk-update";
import FeatureFlagsMatrix from "Pages/FeatureFlags/pages/company-matrix";
import LambdaFunctions from "Pages/LambdaFunctions";
import BugReportView from "Pages/BugReportView";
import RequestsReport from "Pages/RequestsReport";
import Administration from "Pages/Administration";
import SecurityAudits from "Pages/SecurityAudits";
import CompaniesSearch from "Pages/Company/Search";
import CompaniesMatrix from "Pages/Company/Matrix";
import ReviewSnapshots from "Pages/ReviewSnapshots";
import ViewReportSnapshots from "Pages/ViewReportSnapshots";
import RecentlyDeactivated from "Pages/RecentlyDeactivated";
import ViewScheduledNotification from "Pages/ViewScheduleNotification";
import SlowQueries from "Pages/SlowQueries";
import Marketing from "Pages/Marketing";
import EnvironmentStatus from "../Pages/EnvironmentStatus";
import ETLStatus from "../Pages/ETL";
import AI from "../Pages/ai";
import DecisionLogProjects from "../Pages/decision-log/projects";
import DecisionLogItems from "../Pages/decision-log/items";
import JiraTools from "../Pages/jira-tools";
import SchemaReview from "../Pages/SchemaReview";
import GoogleCallback from "../Pages/Login/GoogleCallback";
import SuperUsers from "../Pages/super-users";
import SESLogs from "../Pages/ses-logs";
import Seeder from "../Pages/Seeder";
// code splitting
const Notifications = lazy(() => import("Pages/Notifications"));

const routes = [
	{
		path: "/login/",
		render: (props) => <Login {...props} />,
		title: "Login",
		name: "loginPage",
		hasNavigation: false,
		isPublic: true,
	},
	{
		path: "/mfa-login",
		render: (props) => <MultiFactor {...props} />,
		title: "MfaLogin",
		name: "mfaLoginPage",
		hasNavigation: false,
		isPublic: true,
	},
	{
		path: ["/auth/google/callback", "/auth/google/callback/"],
		render: (props) => <GoogleCallback {...props} />,
		title: "Google Login",
		name: "googleCallbackPage",
		hasNavigation: false,
		isPublic: true,
	},
	{
		path: "/logout",
		render: () => <Logout />,
	},
	{
		path: "/requests",
		render: (props) => <Requests {...props} />,
		title: "Requests",
		name: "requestsPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/",
		render: (props) => <Dashboard {...props} />,
		title: "Dashboard",
		name: "dashboardPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/breadcrumbs",
		render: (props) => <Breadcrumbs {...props} />,
		title: "Breadcrumbs",
		name: "breadcrumbsPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/breadcrumbs/:userID",
		render: (props) => <Breadcrumbs {...props} />,
		title: "Breadcrumbs",
		name: "breadcrumbsPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/breadcrumbs/:userID/:view",
		render: (props) => <Breadcrumbs {...props} />,
		title: "Breadcrumbs",
		name: "breadcrumbsPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/recent",
		render: (props) => <Recent {...props} />,
		title: "Recent Users",
		name: "recentUsersPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/graphs",
		render: (props) => <Graphs {...props} />,
		title: "Graphs",
		name: "graphsPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/graphs/:graphName",
		render: (props) => <Graphs {...props} />,
		title: "Graphs",
		name: "graphsPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/companies/matrix",
		render: (props) => <CompaniesMatrix {...props} />,
		title: "Company Matrix",
		name: "company matrix",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/companies/:companyID",
		render: (props) => <CompanyView {...props} />,
		title: "Company",
		name: "companyPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/companies/:companyID/:view/:viewID?",
		render: (props) => <CompanyView {...props} />,
		title: "Company",
		name: "companyPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/companies",
		render: (props) => <CompaniesSearch {...props} />,
		title: "Companies",
		name: "companiesPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/administration",
		render: (props) => <Administration {...props} />,
		title: "Administration",
		name: "administrationPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/bug-report/:reportID",
		render: (props) => <BugReportView {...props} />,
		title: "Bug Reporting",
		name: "bugReportViewPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/bug-report",
		render: (props) => <BugReport {...props} />,
		title: "Bug Reporting",
		name: "bugReportPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/deactivated",
		render: (props) => <RecentlyDeactivated {...props} />,
		title: "Deactivated Users",
		name: "deactivatedUsersPage",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/review-snapshots",
		render: (props) => <ReviewSnapshots {...props} />,
		title: "Review Snapshots",
		name: "reviewSnapshots",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/review-snapshots/:reportID/:authorID/",
		render: (props) => <ViewReportSnapshots {...props} />,
		title: "Review Snapshot",
		name: "reportSnapshots",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/deployments",
		render: (props) => <Deployments {...props} />,
		title: "Deployments",
		name: "deployments",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/lambda-functions",
		render: (props) => <LambdaFunctions {...props} />,
		title: "Lambda Functions",
		name: "lamdaFunctions",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: ["/notifications", "/notifications/:view/"],
		render: (props) => <Notifications {...props} />,
		title: "Notifications Logger",
		name: "notifications",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/me",
		render: (props) => <Me {...props} />,
		title: "Me",
		name: "me",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/scheduled-notifications/:notificationID",
		render: (props) => <ViewScheduledNotification {...props} />,
		title: "Scheduled Notification",
		name: "scheduledNotification",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/security-audits",
		render: (props) => <SecurityAudits {...props} />,
		title: "Security Audits",
		name: "securityAudits",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/requests-report",
		render: () => <RequestsReport />,
		title: "Requests Report",
		name: "requestsReport",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/flame/:requestID",
		render: () => <FlameChart />,
		title: "Requests Report",
		name: "requestsReport",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/slow-queries/:date/:timeZoneOffsetMilliseconds",
		render: () => <SlowQueries />,
		title: "Slow Queries",
		name: "slowQueries",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/marketing",
		render: () => <Marketing />,
		title: "Marketing",
		name: "marketing",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/me",
		render: () => <Me />,
		title: "Me",
		name: "me",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/environment-status",
		render: () => <EnvironmentStatus />,
		title: "Environment Status",
		name: "environment status",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/etl-status",
		render: () => <ETLStatus />,
		title: "ETL Status",
		name: "ETL-status",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/feature-flags",
		render: () => <FeatureFlags />,
		title: "Feature Flags",
		name: "feature flags",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/feature-flags/matrix",
		render: () => <FeatureFlagsMatrix />,
		title: "Feature Flags",
		name: "feature flags",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/feature-flags/:slug",
		render: (props) => <CreateFeatureFlags {...props} />,
		title: "Create Feature Flag",
		name: "create feature flags",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/feature-flags/bulk/:slug",
		render: (props) => <BulkUpdateFeatureFlag {...props} />,
		title: "Create Feature Flag",
		name: "create feature flags",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/ai/:view",
		render: (props) => <AI {...props} />,
		title: "AI",
		name: "ai-main",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/ai/:view/:id",
		render: (props) => <AI {...props} />,
		title: "AI",
		name: "ai-object",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/decision-log",
		render: (props) => <DecisionLogProjects {...props} />,
		title: "Decision Log Projects",
		name: "decision-log-projects",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/decision-log/projects/:projectId",
		render: (props) => <DecisionLogItems {...props} />,
		title: "Decision Log Items",
		name: "decision-log-items",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/jira-tools",
		render: (props) => <JiraTools {...props} />,
		title: "Jira Tools",
		name: "jira-tools",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/schema-review",
		render: (props) => <SchemaReview {...props} />,
		title: "Schema Review",
		name: "schema-review",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/super-users",
		render: (props) => <SuperUsers {...props} />,
		title: "Super Users",
		name: "super-users",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: "/ses-logs",
		render: (props) => <SESLogs {...props} />,
		title: "SES Logs",
		name: "ses-logs",
		hasNavigation: true,
		isPublic: false,
	},
	{
		path: ["/seed-company", "/seed-company/:view", "/seed-company/:view/:configId"],
		render: (props) => <Seeder {...props} />,
		title: "Seed Company",
		name: "seed-company",
		hasNavigation: true,
		isPublic: false,
	},
];
export default routes;
